class PfStepsCarousel {
	constructor(container) {
		this.container = container;
		this.track = this.container.querySelector(".pf-feature-carousel__track");
		this.slides = [
			...this.container.querySelectorAll(".pf-feature-carousel__slide"),
		];
		this.prevButton = this.container.querySelector(
			".pf-feature-carousel__button--prev",
		);
		this.nextButton = this.container.querySelector(
			".pf-feature-carousel__button--next",
		);

		this.currentIndex = 0;
		this.totalSlides = this.slides.length;

		if (!this.track || !this.slides.length) return;

		this.bindEvents();
		this.update();
	}

	bindEvents() {
		this.prevButton?.addEventListener("click", () => {
			this.goToPrev();
		});

		this.nextButton?.addEventListener("click", () => {
			this.goToNext();
		});

		window.addEventListener("resize", () => {
			this.update();
		});
	}

	goToPrev() {
		if (this.currentIndex > 0) {
			this.currentIndex -= 1;
		} else {
			this.currentIndex = this.totalSlides - 1;
		}

		this.update();
	}

	goToNext() {
		if (this.currentIndex < this.totalSlides - 1) {
			this.currentIndex += 1;
		} else {
			this.currentIndex = 0;
		}

		this.update();
	}

	update() {
		const offset = this.currentIndex * 100;
		this.track.style.transform = `translateX(-${offset}%)`;

		if (this.prevButton) {
			this.prevButton.disabled = this.totalSlides <= 1;
		}

		if (this.nextButton) {
			this.nextButton.disabled = this.totalSlides <= 1;
		}
	}
}

function initPfStepsCarousels() {
	const carousels = document.querySelectorAll(".pf-feature-carousel");

	carousels.forEach((carousel) => {
		if (carousel.dataset.initialized === "true") return;
		carousel.dataset.initialized = "true";
		new PfStepsCarousel(carousel);
	});
}

document.addEventListener("DOMContentLoaded", initPfStepsCarousels);
document.addEventListener("shopify:section:load", initPfStepsCarousels);